<template>
  <div class="footer-box">
    <!-- <search></search> -->
    <div class="QRcode">
      <img src="https://mediakit.enabot.com/eboX/img/pc/Qrimg.png" alt="">
    </div>
    <div @click="goToFacebook" class="join-box">
      Join EBO X Group
    </div>
    <div v-if="ExploreUrl" class="Explore-box">
      <img @click="goHome" src="https://mediakit.enabot.com/eboX/img/pc/ExploreImg.png" alt="">
    </div>
  </div>


</template>
<script>
// import search from './search.vue';
export default {
  props:['ExploreUrl'],
  data() {
    return {
    }

  },
  methods: {
    goToFacebook() {
      window.open("https://www.facebook.com/groups/3167832886862481")
    },
    goHome() {
      if(this.ExploreUrl){
        window.location.href = this.ExploreUrl
      }
    }
  },
  // components: {
  //   search,
  // },
}
</script>
<style lang="scss" scoped>
.footer-box {
  width: 100%;
  margin: 0 auto;
  background: #040D32;
  padding-bottom: 160px;
}

// .search {
//   max-width: 1200px;
//   height: 480px;
//   margin: 0 auto;
//   background: url('../../../assets/pc/EnterImg.png');
//   background-size: 100% 100%;
//   padding-top: 283px;
//   // margin-bottom: 119px;

//   .search-box {
//     max-width: 776px;
//     display: flex;
//     margin: 0 auto;
//     border-radius: 10px;
//     padding-left: 27px;

//     .inputSt {
//       background: #FFF;
//       width: 70.8%;
//       height: 76px;
//       border-radius: 10px 0px 0px 10px;
//       padding-left: 27px;
//     }

//     .Btn {
//       // width: 202px;
//       width: 29.1%;
//       height: 77px;
//       position: relative;
//       left: -1px;
//       top: -1px;
//       background: linear-gradient(to left, #3988ff, #00fcff);
//       background-size: 100% 100%;
//       margin-bottom: 2px;
//       line-height: 77px;
//     }
//   }


// }

.QRcode {
  width: 207px;
  height: 207px;
  margin: 0 auto;
  margin-top: 118px;

  img {
    width: 100%;
    height: 100%;
  }
}

.join-box {
  cursor: pointer;
  width: 320px;
  // height: 64px;
  margin: 0 auto;
  border-radius: 64px;
  background: url("../../../assets/pc/btnBack.png");
  background-size: 100% 100%;
  text-align: center;
  margin-top: 24px;
  font-size: 30px;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 64px;
}

.Explore-box {
  max-width: 1200px;
  margin: 0 auto;
  padding: 120px 0 0 0;
  img {
    width: 100%;
    height: auto;
    cursor: pointer;
  }
}
</style>